/* =======================================================
   LUMINOSO JEWELRY — luminos-v3.js
   Maison Edition JS — no libraries, pure craft
   Fixes:
   - ATC-Button beschriftet gem. § 312j Abs.3 BGB
   - Cart Drawer vollständig
   - Variant-Preis korrekt formatiert (EUR, Komma)
   ======================================================= */
'use strict';

/* ── CUSTOM CURSOR (Desktop only) ──────────────────── */
(function(){
  if(window.matchMedia('(pointer:coarse)').matches) return;
  var dot=document.createElement('div'),ring=document.createElement('div');
  dot.className='cursor-dot'; ring.className='cursor-ring';
  document.body.append(dot,ring);
  var mx=-100,my=-100,rx=-100,ry=-100;
  document.addEventListener('mousemove',function(e){
    mx=e.clientX; my=e.clientY;
    dot.style.left=mx+'px'; dot.style.top=my+'px';
  });
  (function animRing(){
    rx+=(mx-rx)*.12; ry+=(my-ry)*.12;
    ring.style.left=rx+'px'; ring.style.top=ry+'px';
    requestAnimationFrame(animRing);
  })();
  document.addEventListener('mouseover',function(e){
    if(e.target.closest('a,button,[data-cursor-hover],input,select'))ring.classList.add('hover');
  });
  document.addEventListener('mouseout',function(e){
    if(e.target.closest('a,button,[data-cursor-hover],input,select'))ring.classList.remove('hover');
  });
})();

/* ── SCROLL REVEAL ─────────────────────────────────── */
(function(){
  var els=document.querySelectorAll('.reveal,.reveal-scale');
  if(!els.length) return;
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){e.target.classList.add('in-view');io.unobserve(e.target);}
      });
    },{threshold:.08,rootMargin:'0px 0px -50px 0px'});
    els.forEach(function(el){io.observe(el);});
  } else {
    els.forEach(function(el){el.classList.add('in-view');});
  }
})();

/* ── STICKY HEADER ─────────────────────────────────── */
(function(){
  var hdr=document.querySelector('.site-header');
  if(!hdr) return;
  function onScroll(){hdr.classList.toggle('scrolled',window.scrollY>40);}
  window.addEventListener('scroll',onScroll,{passive:true});
  onScroll();
})();

/* ── MONEY FORMATTER ───────────────────────────────── */
function lxFormatMoney(cents){
  return (cents/100).toFixed(2).replace('.',',')+'\u00a0EUR';
}

/* ── CART DRAWER ───────────────────────────────────── */
window.LuminosoCart={
  open:function(){
    var d=document.getElementById('CartDrawer'),o=document.getElementById('CartOverlay');
    if(d){d.classList.add('open');d.setAttribute('aria-hidden','false');}
    if(o){o.style.opacity='1';o.style.pointerEvents='all';}
    document.body.style.overflow='hidden';
    this.refresh();
  },
  close:function(){
    var d=document.getElementById('CartDrawer'),o=document.getElementById('CartOverlay');
    if(d){d.classList.remove('open');d.setAttribute('aria-hidden','true');}
    if(o){o.style.opacity='0';o.style.pointerEvents='none';}
    document.body.style.overflow='';
  },
  refresh:function(){
    var self=this;
    fetch('/cart.js')
      .then(function(r){return r.json();})
      .then(function(cart){
        self.updateCount(cart.item_count);
        self.renderItems(cart);
      })
      .catch(function(e){console.warn('Cart error',e);});
  },
  updateCount:function(n){
    var b=document.getElementById('CartCount');
    if(!b) return;
    b.textContent=n;
    b.style.display=n>0?'flex':'none';
  },
  renderItems:function(cart){
    var el=document.getElementById('CartDrawerItems'),tot=document.getElementById('CartDrawerTotal');
    if(!el) return;
    if(cart.item_count===0){
      el.innerHTML='<div style="padding:48px 0;text-align:center;color:var(--mid)"><p style="font-family:var(--fd);font-size:1.1rem;font-style:italic;margin-bottom:8px">Ihr Warenkorb ist leer</p><p style="font-size:10px;letter-spacing:.15em;text-transform:uppercase;color:var(--light)">Entdecken Sie unsere Kollektion</p></div>';
      if(tot) tot.innerHTML='';
      return;
    }
    el.innerHTML=cart.items.map(function(item){
      return '<div style="display:grid;grid-template-columns:80px 1fr;gap:16px;padding:18px 0;border-bottom:1px solid var(--brd)">'+
        (item.image?'<div style="aspect-ratio:1/1;overflow:hidden;border-radius:4px;background:var(--c2)"><img src="'+item.image+'" alt="'+item.product_title+'" style="width:100%;height:100%;object-fit:cover" loading="lazy"></div>':'<div style="aspect-ratio:1/1;background:var(--c2);border-radius:4px"></div>')+
        '<div style="display:flex;flex-direction:column;justify-content:space-between;padding:2px 0">'+
          '<p style="font-family:var(--fd);font-size:13px;color:var(--char);line-height:1.3;margin-bottom:4px">'+item.product_title+'</p>'+
          (item.variant_title&&item.variant_title!=='Default Title'?'<p style="font-size:10px;letter-spacing:.1em;color:var(--light);text-transform:uppercase;margin-bottom:4px">'+item.variant_title+'</p>':'')+
          '<div style="display:flex;justify-content:space-between;align-items:center">'+
            '<span style="font-family:var(--fd);font-size:14px;color:var(--gold)">'+lxFormatMoney(item.final_price)+'</span>'+
            '<button onclick="window.LuminosoCart.removeItem(\''+item.key+'\')"; style="font-family:var(--fu);font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:var(--light);background:none;border:none;cursor:pointer;transition:color var(--tr)" onmouseover="this.style.color=\'var(--char)\'" onmouseout="this.style.color=\'var(--light)\'">Entfernen</button>'+
          '</div>'+
        '</div>'+
      '</div>';
    }).join('');
    if(tot) tot.innerHTML='<span style="font-size:12px;letter-spacing:.1em;text-transform:uppercase;color:var(--mid)">Zwischensumme</span><strong style="font-family:var(--fd);font-size:1.2rem;font-weight:400;color:var(--char)">'+lxFormatMoney(cart.total_price)+'</strong>';
  },
  removeItem:function(key){
    var self=this;
    fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:0})
    }).then(function(){self.refresh();}).catch(function(e){console.warn(e);});
  }
};

/* Initial cart count */
(function(){
  fetch('/cart.js')
    .then(function(r){return r.json();})
    .then(function(cart){window.LuminosoCart.updateCount(cart.item_count);})
    .catch(function(){});
})();

/* ── TOAST ──────────────────────────────────────────── */
window.LuxToast=function(msg,dur){
  var t=document.getElementById('LuxToast');
  if(!t) return;
  t.textContent=msg;
  t.classList.add('show');
  clearTimeout(t._t);
  t._t=setTimeout(function(){t.classList.remove('show');},dur||3000);
};

/* ── ATC FORM ───────────────────────────────────────── */
/* Pflichtbeschriftung § 312j Abs. 3 BGB */
(function(){
  var form=document.getElementById('ProductForm');
  if(!form) return;
  form.addEventListener('submit',function(e){
    e.preventDefault();
    var btn=document.getElementById('AddToCart');
    var lbl=document.getElementById('AtcLabel');
    if(btn) btn.disabled=true;
    if(lbl) lbl.textContent='Wird hinzugef\u00fcgt\u2026';
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/x-www-form-urlencoded'},
      body:new URLSearchParams(new FormData(form))
    })
    .then(function(r){return r.json();})
    .then(function(data){
      if(data.status){
        if(window.LuxToast) window.LuxToast('Fehler: '+data.description,4000);
      } else {
        if(window.LuxToast) window.LuxToast('\u2713 '+data.title+' hinzugef\u00fcgt',3000);
        if(window.LuminosoCart) window.LuminosoCart.open();
      }
    })
    .catch(function(){
      if(window.LuxToast) window.LuxToast('Fehler beim Hinzuf\u00fcgen',4000);
    })
    .finally(function(){
      if(btn) btn.disabled=false;
      /* § 312j Abs.3 BGB: Button-Beschriftung IMMER wieder auf Pflichttext */
      if(lbl) lbl.textContent='Zahlungspflichtig bestellen';
    });
  });
})();

/* ── VARIANT SELECTOR ───────────────────────────────── */
window.selectVariantOption=function(btn){
  var idx=parseInt(btn.dataset.optionIndex,10);
  var val=btn.dataset.value;
  document.querySelectorAll('[data-option-index="'+idx+'"]').forEach(function(b){
    b.classList.toggle('active',b.dataset.value===val);
    b.setAttribute('aria-pressed',b.dataset.value===val?'true':'false');
  });
  var lbl=document.getElementById('OptVal'+idx);
  if(lbl) lbl.textContent=' '+val;
  var selected=[];
  document.querySelectorAll('.variant-buttons').forEach(function(grp){
    var a=grp.querySelector('.variant-btn.active');
    if(a) selected.push(a.dataset.value);
  });
  var match=(window.productVariants||[]).find(function(v){
    return v.options.every(function(o,i){return o===selected[i];});
  });
  if(!match) return;
  /* Preis updaten */
  var pEl=document.getElementById('ProductPrice');
  if(pEl) pEl.textContent=lxFormatMoney(match.price);
  /* Compare-Preis */
  var cEl=document.getElementById('ComparePrice');
  if(cEl){
    if(match.compare_at_price>match.price){cEl.textContent=lxFormatMoney(match.compare_at_price);cEl.style.display='';}
    else cEl.style.display='none';
  }
  /* Variant-ID */
  var fEl=document.getElementById('FormVariantId');
  if(fEl) fEl.value=match.id;
  /* ATC Button — Pflichtbeschriftung § 312j */
  var atc=document.getElementById('AddToCart'),lbl2=document.getElementById('AtcLabel');
  if(atc){
    atc.disabled=!match.available;
    if(atc.disabled) atc.setAttribute('aria-disabled','true');
    else atc.removeAttribute('aria-disabled');
  }
  if(lbl2) lbl2.textContent=match.available?'Zahlungspflichtig bestellen':'Nicht verf\u00fcgbar';
  /* URL updaten */
  var url=new URL(window.location);
  url.searchParams.set('variant',match.id);
  window.history.replaceState({},'',url);
};

/* ── GALLERY THUMB SWITCH ───────────────────────────── */
window.switchImage=function(src){
  var img=document.getElementById('MainImage');
  if(!img) return;
  img.style.opacity='0';
  setTimeout(function(){
    img.src=src;
    img.onload=function(){img.style.opacity='1';};
  },180);
};

/* ── FAQ ────────────────────────────────────────────── */
(function(){
  document.addEventListener('click',function(e){
    var q=e.target.closest('.faq-question');
    if(!q) return;
    var item=q.closest('.faq-item');
    var open=item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(function(i){i.classList.remove('open');});
    if(!open) item.classList.add('open');
    q.setAttribute('aria-expanded',(!open).toString());
  });
})();

/* ── COUNTER ANIMATION ──────────────────────────────── */
(function(){
  var els=document.querySelectorAll('.lux-proof__num[data-target]');
  if(!els.length||!('IntersectionObserver' in window)) return;
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(!entry.isIntersecting) return;
      var el=entry.target;
      var target=parseFloat(el.dataset.target);
      var suffix=el.dataset.suffix||'';
      var dur=1800,start=performance.now();
      function step(now){
        var t=Math.min((now-start)/dur,1);
        var ease=t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;
        el.textContent=Math.round(ease*target)+suffix;
        if(t<1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      io.unobserve(el);
    });
  },{threshold:.5});
  els.forEach(function(el){io.observe(el);});
})();

/* ── CURSOR CSS ─────────────────────────────────────── */
(function(){
  if(window.matchMedia('(pointer:coarse)').matches) return;
  var s=document.createElement('style');
  s.textContent='.cursor-dot{position:fixed;width:6px;height:6px;background:var(--gold,#B8972A);border-radius:50%;pointer-events:none;z-index:9999;transform:translate(-50%,-50%);transition:opacity .3s}.cursor-ring{position:fixed;width:28px;height:28px;border:1px solid rgba(184,151,42,.5);border-radius:50%;pointer-events:none;z-index:9998;transform:translate(-50%,-50%);transition:width .25s,height .25s,border-color .25s}.cursor-ring.hover{width:40px;height:40px;border-color:var(--gold,#B8972A)}';
  document.head.appendChild(s);
})();
